module.exports = __webpack_public_path__ + "assets/media/sp2.107b7296.mp4";